namespace C2S {

    @C2S.Decorators.registerInterface()
    export class IDoubleValue {
    }

    export interface IDoubleValue {
        get_value(): any;
        set_value(value: any): void;
    }
}